import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'bepatient-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleButtonComponent),
      multi: true
    }
  ],
  standalone: false
})
export class ToggleButtonComponent
  implements AfterViewInit, OnChanges, ControlValueAccessor
{
  @Input() color = 'var(--ion-color-primary)';
  @Input() strong = false;
  @Input() shape = 'round';
  @Input() size = 'default';
  @Input() selected = false;
  @Output() selectedChange = new EventEmitter<boolean>();

  @ViewChild('button', { read: ElementRef, static: true }) button: ElementRef;

  ngAfterViewInit(): void {
    this.update();
  }

  ngOnChanges(): void {
    this.update();
  }

  writeValue(value: any): void {
    if (this.selected !== !!value) {
      this.selected = !!value;
      this.update();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  change(): void {
    this.selected = !this.selected;
    this.propagateChange(this.selected);
    this.selectedChange.emit(this.selected);
    this.update();
  }

  private propagateChange = (fn: any) => {};

  private update(): void {
    const style = this.button.nativeElement.style;
    const bColor = this.selected ? this.color : 'transparent';
    const fColor = this.selected
      ? 'var(--ion-color-primary-contrast)'
      : this.color;

    style.setProperty('--background', bColor);
    style.setProperty('--background-activated', bColor);
    style.setProperty('--background-focused', bColor);
    style.setProperty('--border-color', this.color);
    style.setProperty('--color', fColor);
    style.setProperty('--color-activated', fColor);
    style.setProperty('--color-focused', fColor);
  }
}
